import React, {
  FunctionComponent,
  useCallback,
  useEffect,
  useState,
} from 'react';
import { QuestionType } from './../types';
import StepperInput from './Stepper';
import { useCategoriesOfferContext } from '../context/CategoriesOfferContext';

interface QuestionProps {
  question: QuestionType;
  onAnswer: (key: string) => void;
  disabled: boolean;
  defaultValue?: string | null;
  hideLabel?: boolean;
}

const Question: FunctionComponent<QuestionProps> = ({
  question,
  onAnswer,
  disabled,
  defaultValue,
  hideLabel = false,
}: QuestionProps) => {
  const [radioAnswer, setRadioAnswer] = useState<string | undefined>(undefined);
  const [stepperValue, setStepperValue] = useState<number>(0);
  const { questionErrors, setQuestionErrors } = useCategoriesOfferContext();
  const [toolTip, setToolTip] = useState<boolean>(false);

  const isNumericQuestion = useCallback(
    () => question.key.startsWith('count_'),
    [question.key]
  );

  const onChange = (e: string) => {
    setQuestionErrors(questionErrors.filter((q) => q !== question.id));
    onAnswer(e);
    setRadioAnswer(e);
  };

  const handleStepperChange = (value: number) => {
    setStepperValue(value);
    onAnswer(value.toString());
  };

  useEffect(() => {
    if (defaultValue && isNumericQuestion()) {
      setStepperValue(Number(defaultValue));
    } else if (defaultValue) {
      setRadioAnswer(defaultValue);
    }
  }, [defaultValue, isNumericQuestion, question.key]);

  return (
    <div className="gg-15 py-1">
      {!hideLabel ? (
        <div className="calculator_category_title d-flex align-center m-auto gap-05">
          <h3>{question.label}</h3>
          <div className="calculator_tooltip">
            {question.info?.length && (
              <img
                onClick={() => setToolTip(!toolTip)}
                onMouseEnter={() => setToolTip(true)}
                onMouseLeave={() => setToolTip(false)}
                width={16}
                height={16}
                role="button"
                tabIndex={0}
                className="cursor cursor-pointer"
                src={`${
                  process.env.NODE_ENV !== 'development'
                    ? 'https://painting-frontend.vercel.app'
                    : ''
                }/info.svg`}
                alt="open/close info"
              />
            )}
            {toolTip && (
              <small className="br-05 bg-light-yellow p-05 absolute">
                {question.info}
              </small>
            )}
          </div>
        </div>
      ) : null}
      <div className="calculator_question_wrapper">
        <>
          <div
            className={`calculator_question_wrapper mw-t question-${question.id}`}
            data-toggle="buttons"
          >
            {/* <small className="px-10">{question.info}</small> */}
            {isNumericQuestion() ? (
              <StepperInput
                value={stepperValue}
                onChange={handleStepperChange}
                disabled={disabled}
              />
            ) : (
              question.answers.map((answer) => (
                <div
                  key={answer.id}
                  className="calculator_question_buttonGroup"
                >
                  <label
                    className={`calculator_paint_radio ${
                      answer.key === radioAnswer
                        ? 'calculator_paint_radio_active'
                        : ''
                    }`}
                    tabIndex={0}
                    role="button"
                  >
                    <input
                      type="radio"
                      name={question.id + question.key}
                      onChange={() => onChange(answer.key)}
                      value={answer.key}
                    />
                    <div className="calculator_paint_radio_check">
                      {answer.label}
                    </div>
                  </label>
                </div>
              ))
            )}
          </div>
          {questionErrors.includes(question.id) && (
            <span className="calculator_qerror">Ange: {question.label}</span>
          )}
        </>
      </div>
    </div>
  );
};

export default Question;
